export const FugitiveService = [
  {
    label: "LL",
    value: "Light liquid",
  },
  {
    label: "HL",
    value: "Heavy liquid",
  },
  {
    label: "GV",
    value: "Gas",
  },
  {
    label: "GV",
    value: "Gas/Vapor",
  },
  {
    label: "All",
    value: "all",
  },
];

export const ArrayEquipmentVocSeries = [
  "Agitator",
  "Connection & Flange",
  "Open-ended line",
  "Sampling connection",
  "Valve",
  "Pump",
  "Compressor",
  "Pressure relief device",
];

export const UncheckFugitive = [
  {
    label: "Uncheck 1",
    value: "Uncheck 1",
  },
  {
    label: "Uncheck 2",
    value: "Uncheck 2",
  },
];

export const MenuUploadVocResult = ["/vocs-inventory/fugitive/information-voc-result"];

export const MenuUploadVocSeries = ["/vocs-inventory/fugitive/report-voc-series"];
